// eslint-disable-next-line @typescript-eslint/triple-slash-reference -- ambient global.d.ts has no runtime JS counterpart to import
/// <reference path="./global.d.ts" />
export type ConsentLevel = "required" | "functional" | "advertising";

const withResolvers = {
  advertising: Promise.withResolvers<boolean>(),
  functional: Promise.withResolvers<boolean>(),
  required: Promise.withResolvers<boolean>(),
};

export const callbacks: Record<ConsentLevel, () => void> = {
  advertising: () => {
    withResolvers.advertising.resolve(true);
  },
  functional: () => {
    withResolvers.functional.resolve(true);
  },
  required: () => {
    withResolvers.required.resolve(true);
  },
};
export const required = () => withResolvers.required.promise;
export const functional = () => withResolvers.functional.promise;
export const advertising = () => withResolvers.advertising.promise;
